export const MAINNET_ID = 1;
export const RINKEBY_ID = 4;
export const CONTRACT_ADDRESSES = {
  [MAINNET_ID]: "0x9e1F3e8dB4d1119894624632499eAEd1E56D2b1d",
  [RINKEBY_ID]: "0x1acd678c7c82175f609bed8166675eb45c61c365",
};
